import React from 'react';
import './PortalAccess.css';

export default function PortalAccess({ title, href }) {
  return <div className="portal-access hidethis">
    <span className="portal-access-icon hidethis" aria-hidden="true">🔗</span>
    <div className="portal-access-content hidethis">
      <span className="portal-access-title hidethis">{title}</span>
      <a href={href} target="_blank" rel="noopener noreferrer">{href}</a>
    </div>
  </div>;
}
